// Tanstack recommends using mutation for side effect
// see: https://tanstack.com/query/latest/docs/framework/react/guides/mutations#mutation-side-effects 

import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import { useMutation, useQueryClient } from "react-query";
import { BACKEND_DOMAIN } from "utils/constants";
import { showMutationAlert } from "utils/helpers";
import { documentsQueryKey } from "./queryListDocuments";


const useDownloadDocument = (buildingModelUid: string) => {
    const alert = useAlert();
    const accessToken = useAccessToken();
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: async ( gscPath: string) => {
        const URL = `${BACKEND_DOMAIN}/documents/download?path=${encodeURIComponent(gscPath)}`;

            const response = await fetch(URL, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`Failed to download document: ${response.statusText}`);
            }
            const { url: downloadUrl} = await response.json();
            const downloadResponse = await fetch (downloadUrl, {
                method: "GET",
            })
            
            if (!downloadResponse.ok){
                throw new Error(`Upload to GCS failed: ${downloadResponse.statusText}`);
            }
            // Convert response to blob
            const blob = await downloadResponse.blob();
            
            // Extract filename from the GCS path
            const filename = gscPath.split('/').pop() || 'download';
            
            // Create a temporary URL for the blob - blob is just a binary data and we need a URL object
            const blobUrl = window.URL.createObjectURL(blob);
            
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            
            // Cleanup
            window.URL.revokeObjectURL(blobUrl);
            document.body.removeChild(a);
            
            return downloadResponse;        
        },
        onSuccess: () => {
            alert.success('Your download has started.')
            queryClient.invalidateQueries([...documentsQueryKey, buildingModelUid]);
        },
        onError: (error) => {
            showMutationAlert(error, alert);
        },
    });
}

export default useDownloadDocument
